module.exports = {"id":"211241","name":"Rubén Peña","rating":"74","photo":"./data/images/photos/2/211241.png","club":{"name":"SD Eibar","logo":"./data/images/clubs/SDEibar.png"},"positions":["BU","MD","MG","DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RubenPena0.json
// module id = 3739
// module chunks = 0